var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22px",
    height: "22px",
    viewBox: "0 6 256 256",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 6,
    d: "M 86.5,255.5 C 86.1667,255.5 85.8333,255.5 85.5,255.5C 57.5616,228.062 29.7283,200.395 2,172.5C 1.33333,170.833 1.33333,169.167 2,167.5C 41.8333,127.667 81.6667,87.8333 121.5,48C 142.419,46.8549 163.419,46.0216 184.5,45.5C 186.524,39.6446 190.19,35.1446 195.5,32C 213.312,24.8459 230.145,16.0126 246,5.5C 249.137,6.94492 249.303,8.77825 246.5,11C 231.665,21.4189 215.665,29.7522 198.5,36C 194.447,38.3867 191.447,41.72 189.5,46C 196.167,46.3333 202.833,46.6667 209.5,47C 210.766,47.3095 211.933,47.8095 213,48.5C 213.982,75.92 213.649,103.253 212,130.5C 170.272,172.395 128.438,214.062 86.5,255.5 Z  M 125.5,54.5 C 144.845,54.1671 164.178,54.5004 183.5,55.5C 182.754,56.7362 182.421,58.0695 182.5,59.5C 169.962,62.2426 166.128,69.5759 171,81.5C 179,89.5 187,89.5 195,81.5C 199.761,72.3558 197.595,65.3558 188.5,60.5C 187.369,58.9255 187.202,57.2588 188,55.5C 193.741,54.5251 199.575,54.1918 205.5,54.5C 205.667,78.5023 205.5,102.502 205,126.5C 165.333,166.167 125.667,205.833 86,245.5C 60.8333,220.333 35.6667,195.167 10.5,170C 49.0348,131.632 87.3681,93.132 125.5,54.5 Z  M 180.5,64.5 C 189.006,64.1704 192.839,68.1704 192,76.5C 189.367,81.7315 185.201,83.5649 179.5,82C 173.628,78.9844 172.128,74.4844 175,68.5C 176.5,66.5313 178.333,65.198 180.5,64.5 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 6,
    d: "M 117.5,100.5 C 121.071,100.408 122.238,102.074 121,105.5C 111.822,138.545 102.489,171.545 93,204.5C 90.8333,206 89.3333,205.5 88.5,203C 98.0781,168.771 107.745,134.604 117.5,100.5 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 6,
    d: "M 78.5,121.5 C 91.6675,121.166 97.8341,127.499 97,140.5C 91.9725,150.844 84.1392,153.677 73.5,149C 66.2012,143.447 64.7012,136.614 69,128.5C 71.5046,125.147 74.6713,122.814 78.5,121.5 Z M 79.5,126.5 C 73.4525,128.728 70.9525,133.061 72,139.5C 77.5204,147.955 83.8537,148.622 91,141.5C 93.5402,131.853 89.7069,126.853 79.5,126.5 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 6,
    d: "M 122.5,153.5 C 135.667,153.166 141.834,159.499 141,172.5C 135.973,182.844 128.139,185.677 117.5,181C 110.201,175.447 108.701,168.614 113,160.5C 115.505,157.147 118.671,154.814 122.5,153.5 Z M 123.5,158.5 C 117.453,160.728 114.953,165.061 116,171.5C 121.52,179.955 127.854,180.622 135,173.5C 137.54,163.853 133.707,158.853 123.5,158.5 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.20cd6014520825f5db7e0a3836c131ec.svg";
export { ForwardRef as ReactComponent };